import { Injectable } from "@angular/core";
import { Observable, catchError, retry } from "rxjs";
import { BaseService } from "./base.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";

@Injectable({
    providedIn: 'root'
  })
  export class GeosysManagementService extends BaseService {

    private API_GEOSYS_MANAGEMENT_URL = this.API_BASE_URL + "geosys-management"; 

    constructor(private httpClient: HttpClient,
        public _snackBar: MatSnackBar,
        public cookieService: CookieService,
        public translate: TranslateService) {
            super()
      }

    ////////////////////////////////////////////////////////////////////////////
    //////////////////                GET                     //////////////////
    ////////////////////////////////////////////////////////////////////////////

    getGeosysFieldId(fieldId: number): Observable<any> {
      return this.httpClient.get<any>(this.API_GEOSYS_MANAGEMENT_URL + "/satelliteHistory/getGeosysFieldId?fieldId=" + fieldId)
        .pipe(
          retry(1),
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.GEOSYS-FIELD-ID'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    geosysPartialNdviImage(geosysFieldId: string, date: string): Observable<any> {
      return this.httpClient.get(this.API_GEOSYS_MANAGEMENT_URL + "/satelliteHistory/geosysPartialNdvi?geosysFieldId=" + geosysFieldId + "&date=" + date)
        .pipe(
          retry(1),
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.PARTIAL-NDVI'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }


    /**
     * All Geosys-subscribed fields for a farm in one call (premium imagery badge).
     * Lean pattern: no snackbar here — global interceptor handles errors.
     */
    getFarmSubscribedFields(farmId: number): Observable<{ fieldId: number; geosysFieldId: string; active: boolean }[]> {
      return this.httpClient.get<{ fieldId: number; geosysFieldId: string; active: boolean }[]>(
        this.API_GEOSYS_MANAGEMENT_URL + `/farm/${farmId}/subscribedFields`);
    }

    getFieldCoveragePercentageByFieldId(fieldId:number, provider?: string): Observable<any> {
      //console.log(fieldId, 'fieldId');
      //console.log("provider", provider);

      let params = new HttpParams()

      if(provider){
         params = params.append('provider', provider);
      }
        return this.httpClient.get<any>(this.API_GEOSYS_MANAGEMENT_URL +`/field/${fieldId}/coverage/percentage`, {params})
            .pipe(
                catchError(err => {
                    this.hasError.next(true);
                    this._snackBar.open(this.translate.instant('DATA-SERVICE.ANALYSIS'), this.translate.instant('SNACKBAR.DISMISS'), {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    /**
     * Every Geosys NDVI pass on one field, best coverage per date, newest first.
     * Includes passes too cloudy to have produced a map. Lean pattern: the
     * caller (MapsImageryService) handles errors.
     */
    getFieldCoveragePasses(fieldId: number, from?: string, to?: string): Observable<{ date: string; coverage: number }[]> {
      return this.httpClient.get<{ date: string; coverage: number }[]>(
        this.API_GEOSYS_MANAGEMENT_URL + `/field/${fieldId}/coverage/passes`, { params: this.passParams(from, to) });
    }

    /**
     * Per date, how many of a farm's subscribed fields had a clear, partly
     * cloudy or cloudy pass. A field with no pass on a date is in none of the
     * three counts. Lean pattern, as above.
     */
    getFarmCoveragePasses(farmId: number, from?: string, to?: string): Observable<{
      subscribedFields: number;
      passes: { date: string; clear: number; partly: number; cloudy: number }[];
    }> {
      return this.httpClient.get<{
        subscribedFields: number;
        passes: { date: string; clear: number; partly: number; cloudy: number }[];
      }>(this.API_GEOSYS_MANAGEMENT_URL + `/farm/${farmId}/coverage/passes`, { params: this.passParams(from, to) });
    }

    /** A missing bound is left off, which the API reads as unbounded on that side. */
    private passParams(from?: string, to?: string): HttpParams {
      let params = new HttpParams();
      if (from) { params = params.set('from', from); }
      if (to) { params = params.set('to', to); }
      return params;
    }



    ////////////////////////////////////////////////////////////////////////////
    ////////////////////             INSERT                  ///////////////////
    ////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////
    ////////////////////             UPDATE                  ///////////////////
    ////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////
    ////////////////////             DELETE                  ///////////////////
    ////////////////////////////////////////////////////////////////////////////
    
  }  